import React from "react";
import { Paper, Box, Typography, Divider } from "@mui/material";

export default function DataCard({
  title,
  action,
  children,
  noPadding = false,
  sx = {},
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        width: "100%",
        backgroundColor: "rgba(255,255,255,0.97)",
        borderRadius: 2,
        border: "1px solid rgba(255,255,255,0.5)",
        boxShadow: "0 6px 24px rgba(15,23,42,0.18)",
        overflow: "hidden",
        ...sx,
      }}
    >
      {(title || action) && (
        <>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
              px: 3,
              py: 2,
            }}
          >
            {title && (
              <Typography
                sx={{
                  fontSize: "1rem",
                  fontWeight: 600,
                  color: "#0F172A",
                  letterSpacing: -0.1,
                }}
              >
                {title}
              </Typography>
            )}
            {action && <Box>{action}</Box>}
          </Box>
          <Divider sx={{ borderColor: "rgba(15,23,42,0.08)" }} />
        </>
      )}
      <Box sx={{ p: noPadding ? 0 : 3 }}>{children}</Box>
    </Paper>
  );
}

export const tableHeaderCellSx = {
  color: "#64748B",
  fontWeight: 700,
  fontSize: "0.7rem",
  textTransform: "uppercase",
  letterSpacing: 1.1,
  borderBottom: "2px solid #E2E8F0",
  backgroundColor: "#F8FAFC",
  py: 1.5,
};
